export default __webpack_public_path__ + "static/media/Lost Apes Logo.11c903e7.png";